<template>
  <div class="slider-container">
    <div class="arrow-left" @click="movePrev"></div>
    <div class="slider-wrapper">
      <div class="slider-body">
        <div class="slider-header" :class="{ 'anim-text-left': moveLeft, 'anim-text-right': moveRight }" v-touch:swipe="moveSwipe">
          <div class="slider-flag">
            <img :src="data.flag" alt />
          </div>
          <div class="slider-name-block">
            <div class="slider-name">{{ data.whoFirst }}</div>
            <div class="slider-name">{{ data.whoLast }}</div>
            <div class="slider-stars slider-stars-hidden">
              <div class="mark-1">{{ ratio }}</div>
              <div class="star"></div>
              <div class="star"></div>
              <div class="star"></div>
              <div class="star"></div>
              <div :class="lastStarClass(ratio)"></div>
            </div>
          </div>
        </div>
        <div class="slider-assessment-block">
          <div class="slider-stars" v-touch:swipe="moveSwipe" :class="{ 'anim-text-left': moveLeft, 'anim-text-right': moveRight }">
            <div class="mark-1">{{ ratio }}</div>
            <div class="star"></div>
            <div class="star"></div>
            <div class="star"></div>
            <div class="star"></div>
            <div :class="lastStarClass(ratio)"></div>
          </div>
          <div class="slider-assessment">
            <div class="slider-bl">
              <span class="slider-word">Quality:</span>
              <span class="mark-2">{{ roundVal(data.score.quality) }}</span>
            </div>
            <div class="slider-bl">
              <span class="slider-word">Schedule:</span>
              <span class="mark-2">{{ roundVal(data.score.schedule) }}</span>
            </div>
            <div class="slider-bl">
              <span class="slider-word">Cost:</span>
              <span class="mark-2">{{ roundVal(data.score.cost) }}</span>
            </div>
            <div class="slider-bl">
              <span class="slider-word">Willing to refer:</span>
              <span class="mark-2">
                {{
                roundVal(data.score.willingToRefer)
                }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-touch:swipe="moveSwipe"
          class="slider-text-block"
          :class="{ 'anim-text-left': moveLeft, 'anim-text-right': moveRight }"
        >
          <div class="slider-text-1">{{ data.textHead }}</div>
          <div class="slider-text-2">{{ data.description }}</div>
        </div>
      </div>
      <div class="slider-pagination">
        <div
          v-for="index in feedBack.length"
          :key="index"
          class="pag"
          :class="{ selected: feedPosition === index - 1 }"
          @click="changeFeedBack(index - 1)"
        ></div>
      </div>
    </div>
    <div class="arrow-right" @click="moveNext"></div>
  </div>
</template>

<script>
import feedBackDataCode from "../configs/slider";

export default {
  name: "FeedBack",
  data: () => ({
    feedBack: feedBackDataCode,
    data: null,
    feedPosition: 0,
    moveLeft: false,
    moveRight: false
  }),
  computed: {
    ratio: function() {
      let props = 0;
      let len = 0;
      for (const prop in this.data.score) {
        len += 1;
        props += this.data.score[prop];
      }
      return parseFloat(props / len).toFixed(1);
    }
  },
  created: function() {
    this.data = this.feedBack[0];
  },
  methods: {
    lastStarClass(ratio) {
      if (ratio > 4.9) return "star";
      else if (ratio > 4) return "star-half";
      else return "star-empty";
    },
    moveSwipe(e) {
      if (e === "left") this.moveNext();
      if (e === "right") this.movePrev();
    },
    changeFeedBack(index) {
      if (index === this.feedPosition) {
        return;
      }
      this.moveRight = false;
      this.moveLeft = false;

      const moveLeft = index - this.feedPosition > 0;
      setTimeout(() => {
        this.feedPosition = index;
        this.data = this.feedBack[this.feedPosition];
        if (moveLeft) {
          this.moveLeft = true;
        } else {
          this.moveRight = true;
        }
      }, 50);
    },
    moveNext() {
      this.moveRight = false;
      this.moveLeft = false;
      // this.invisible = 0

      setTimeout(() => {
        const len = this.feedBack.length;
        this.feedPosition = (this.feedPosition + 1) % len;
        this.data = this.feedBack[this.feedPosition];
        // this.invisible = 1
        this.moveLeft = true;
      }, 50);
    },
    movePrev() {
      this.moveLeft = false;
      this.moveRight = false;

      // this.invisible = 0

      setTimeout(() => {
        const len = this.feedBack.length;
        this.feedPosition =
          (this.feedPosition > 0 ? --this.feedPosition : len - 1) % len;

        this.data = this.feedBack[this.feedPosition];
        // this.invisible = 1
        this.moveRight = true;
      }, 50);
    },
    roundVal(val) {
      return parseFloat(val).toFixed(1);
    }
  }
};
</script>

<style lang="scss">
.slider-container {
  display: flex;
  max-width: 1044px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1130px) {
    justify-content: space-around;
  }

  @media screen and (max-width: 900px) {
    justify-content: space-around;
  }
}

.slider-body {
  width: 700px;
  height: 507px;
  background: #ffffff;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  border-radius: 0px 85px;

  @media screen and (max-width: 900px) {
    width: 668px;
  }

  @media screen and (max-width: 767px) {
    height: initial;
    width: initial;
    box-shadow: none;
  }
}

.slider-stars-hidden {
  display: none !important;

  @media screen and (max-width: 767px) {
    display: flex !important;
    margin-left: 20px;
  }
}

.slider-wrapper {
  @media screen and (max-width: 767px) {
    width: 440px;
    height: 487px;
    background: #ffffff;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12);
    border-radius: 0px 85px;
  }

  @media screen and (max-width: 479px) {
    width: 100%;
    border-radius: inherit;
  }
}

.slider-header {
  display: flex;
  padding-top: 51px;
  padding-bottom: 21px;

  @media screen and (max-width: 767px) {
    padding-top: 28px;
  }
}

.slider-flag {
  margin-left: 100px;

  @media screen and (max-width: 900px) {
    margin-left: 84px;
  }

  @media screen and (max-width: 767px) {
    margin-left: 73px;
  }

  @media screen and (max-width: 479px) {
    margin-left: 20px;
  }
}

.slider-name-block {
  margin-left: 30px;

  @media screen and (max-width: 479px) {
    margin-left: 21px;
  }
}

.slider-name {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 36px;
  line-height: 42px;
  color: #000000;

  @media screen and (max-width: 767px) {
    font-size: 24px;
    line-height: 28px;
  }

  @media screen and (max-width: 374px) {
    font-size: 22px;
    line-height: 26px;
  }
}

.slider-assessment-block {
  width: 700px;
  height: 67px;
  background: #ebf1f4;

  @media screen and (max-width: 900px) {
    width: 668px;
  }

  @media screen and (max-width: 767px) {
    width: 440px;
    display: flex;
    height: 64px;
  }
  @media screen and (max-width: 479px) {
    width: 100%;
    height: 55px;
  }
}

.slider-stars,
.slider-assessment {
  width: 424px;
  margin-left: 100px;
  display: flex;
  align-items: center;

  @media screen and (max-width: 900px) {
    margin-left: 84px;
  }
}

.slider-stars {
  padding-top: 4px;

  @media screen and (max-width: 767px) {
    display: none;
  }

  @media screen and (max-width: 767px) {
    margin-left: 0;
    font-size: 24px;
    line-height: 28px;
  }
}

.slider-word {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #000000;

  @media screen and (max-width: 479px) {
    margin-bottom: 2px;
  }
}

.mark-1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 35px;
  margin-right: 10px;
  color: #69a8cb;
}

.star {
  margin-left: 4px;
  width: 16px;
  height: 16px;
  background-image: url("../assets/img/Star.svg");
  background-position: center;
}

.star-half {
  margin-left: 4px;
  width: 16px;
  height: 16px;
  background-image: url("../assets/img/half-star.svg");
  background-position: center;
  position: relative;
  top: 1px;
}

.slider-assessment {
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    margin: 0 42px;
  }
  @media screen and (max-width: 479px) {
    margin: 0 20px;
  }
}

.slider-bl {
  display: flex;
  align-items: center;

  @media screen and (max-width: 767px) {
    flex-direction: column;
    /* justify-content: center; */
    min-height: 44px;
    justify-content: space-between;
  }
  @media screen and (max-width: 479px) {
    min-height: 31px;
  }
}

.mark-2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #69a8cb;
  margin-left: 5px;
  @media screen and (max-width: 479px) {
    margin-left: 0;
  }
}

.slider-text-block {
  padding-top: 36px;
  width: 500px;
  margin: 0 auto;
  position: relative;

  @media screen and (max-width: 767px) {
    padding-top: 17px;
    width: initial;
  }
  @media screen and (max-width: 479px) {
    padding-top: 20px;
    height: 192px;
  }

  @media screen and (max-width: 374px) {
  }
}

.slider-text-1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #000000;

  @media screen and (max-width: 767px) {
    margin: 0 15px;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
  }
}

.slider-text-2 {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  color: #000000;
  margin-top: 17px;

  @media screen and (max-width: 767px) {
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    height: 118px;
    margin: 17px 15px 0;
  }
  @media screen and (max-width: 479px) {
    margin-top: 16px;
    min-height: 118px;
  }
}
.slider-pagination {
  margin: 40px auto 0;
  width: 115px;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 479px) {
    margin-top: 20px;
  }
  @media screen and (max-width: 374px) {
    margin-top: 40px;
  }
}

.pag {
  width: 8px;
  height: 8px;
  left: 970px;
  top: 6755px;
  background: #156072;
  opacity: 0.8;
  border-radius: 50px;

  @media screen and (max-width: 767px) {
    background: #023a5a;
    opacity: 0.21;
  }
}

.selected {
  width: 35px;
  height: 8px;
  left: 923px;
  top: 6755px;

  background: #69a8cb;
  border-radius: 5px;

  @media screen and (max-width: 767px) {
    background: #023a5a;
    opacity: 1;
  }
}

.arrow-left,
.arrow-right {
  width: 41px;
  height: 38px;
  background-repeat: no-repeat;
  cursor: pointer;

  @media screen and (max-width: 900px) {
    display: none;
  }
}

.arrow-left {
  background-image: url("../assets/img/left.png");
  margin-bottom: 20px;
  // opacity: 0.5;

  &:hover {
    background-image: url("../assets/img/left-yellow.svg");
  }
}

.arrow-right {
  background-image: url("../assets/img/right.svg");
  margin-bottom: 20px;
  // opacity: 0.5;
  &:hover {
    background-image: url("../assets/img/right-yellow.svg");
  }
}

.anim-text-left {
  animation: moveLeft 0.5s;
}
.anim-text-right {
  animation: moveRight 0.5s;
}

@keyframes moveLeft {
  from {
    left: 30px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes moveRight {
  from {
    left: -30px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}
</style>
